import { writable } from 'svelte/store';
import type {
  RetrieveProfileResponse,
  RetrieveUserIdentifier,
} from '$shared/api';
import { client } from '$lib/api/Client';

export const profilePreview = {
  isOpen: writable(false),
  showMessageModal: writable(false),
  profile: writable<RetrieveProfileResponse | null>(null),

  preview: async (identifier: RetrieveUserIdentifier) => {
    try {
      const profile = await client.users.retrieveProfile(identifier);
      profilePreview.profile.set(profile);
      profilePreview.isOpen.set(true);
    } catch (error) {
      console.error(error);
    }
  },

  reset: () => {
    profilePreview.isOpen.set(false);
    profilePreview.showMessageModal.set(false);
    profilePreview.profile.set(null);
  },

  openMessageModal: () => {
    profilePreview.showMessageModal.set(true);
  },
};
